import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const NOTIFICATION_DEFINITIONS_QUERY_KEY = 'notification-definitions';

const getNotificationDefinitionsQueryOptions = () =>
  queryOptions({
    queryKey: [NOTIFICATION_DEFINITIONS_QUERY_KEY] as const,
    queryFn: async () => {
      const { data } = await apiClient.notifications.listDefinitions();
      return data?.items ?? [];
    },
  });

/**
 * Notification catalog definitions (GET /v1/notifications/definitions).
 * The REST endpoint returns the whole catalog (bounded by design), so no
 * pagination is needed here.
 */
export const useNotificationDefinitionsQuery = () => {
  const { data, isLoading, error, refetch } = useQuery(
    getNotificationDefinitionsQueryOptions()
  );

  return { definitions: data, isLoading, error, refetch };
};
